<nb-header>
  <div class="db-header-base__link-item">
    @if (sessionStorage.getItem('selectedFknKey')) {
    <p class="d-flex flex-row space-between">
      <db-icon class="mr-2">profile</db-icon>
      {{ 'HEADER.' + getAppThemeName() + '.bcn' | translate }}: {{ sessionStorage.getItem('selectedFknKey') }}
    </p>
    }
  </div>
</nb-header>
